module.exports = __webpack_public_path__ + "img/BVB.370b8204.png";